import { Tooltip } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { FetchError } from '../../../common/api/api';
import ExportButton from '../../../common/ExportButton';
import { useCheckIfHasTemplate } from '../../template/Template.hooks';
import { TemplateType } from '../../template/Template.interface';
import { WorkflowEntity } from '../../workflow/Workflow.interface';
import { useExportRiskDocument } from '../Risk.hook';

export interface RiskExportButtonProps {
  onError?: (error: FetchError) => void;
}

const RiskExportButton: React.FC<RiskExportButtonProps> = ({ onError }) => {
  const [templateAvailable, setTemplateAvailable] = useState(false);
  const [{ isLoading, error, response }, getDocument, downloadDocument] =
    useExportRiskDocument();

  const [{ data: ifHasTemplate }, get] = useCheckIfHasTemplate(
    TemplateType.Risk
  );

  useEffect(() => {
    response?.ok && downloadDocument('Risk Document.docx');
  }, [response]);

  useEffect(() => {
    if (ifHasTemplate) {
      setTemplateAvailable(true);
    } else {
      setTemplateAvailable(false);
    }
  }, [ifHasTemplate]);

  useEffect(() => {
    get();
  }, [get]);

  useEffect(() => {
    error && onError?.(error);
  }, [error]);

  return (
    <ExportButton
      templateAvailable={templateAvailable}
      isLoading={isLoading}
      onClick={() => getDocument({ entity: WorkflowEntity.Risk })}
    />
  );
};
export default RiskExportButton;
